module.exports = __webpack_public_path__ + "static/media/banknote-icon.fe790a34.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/banknote-icon.svg
// module id = 3265
// module chunks = 0